// extracted by mini-css-extract-plugin
export default {"shimmerWrapper":"SidePannelShimmer_shimmerWrapper__9laKJ","shimmer":"SidePannelShimmer_shimmer__E+IOK"};